import { useState, useEffect, useRef } from 'react';
import { useI18n } from '../i18n';
import './FontSizeToggle.css';

const STORAGE_KEY = 'sudoku_cell_font_scale';
const DEFAULT_SCALE = 115; // percent — varsayılan olarak biraz büyük

export function FontSizeToggle() {
  const { t } = useI18n();
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const [scale, setScale] = useState<number>(() => {
    const s = localStorage.getItem(STORAGE_KEY);
    return s ? parseInt(s, 10) : DEFAULT_SCALE;
  });

  // CSS değişkenini güncelle
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--cell-font-scale',
      (scale / 100).toFixed(2),
    );
    localStorage.setItem(STORAGE_KEY, String(scale));
  }, [scale]);

  // Mount anında başlangıç değerini uygula
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    const initial = saved ? parseInt(saved, 10) : DEFAULT_SCALE;
    document.documentElement.style.setProperty(
      '--cell-font-scale',
      (initial / 100).toFixed(2),
    );
  }, []);

  // Dışarı tıklayınca kapat
  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div className="font-size-toggle" ref={ref}>
      <button
        className={`global-ctrl-btn icon-btn font-size-btn${open ? ' active' : ''}`}
        onClick={() => setOpen(o => !o)}
        title={t.common.fontSize}
        aria-label={t.common.fontSize}
        aria-expanded={open}
      >
        {/* Aa ikonu */}
        <svg
          width="18"
          height="16"
          viewBox="0 0 26 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <text
            x="0"
            y="16"
            fontSize="17"
            fontWeight="700"
            fontFamily="system-ui,sans-serif"
          >
            A
          </text>
          <text
            x="17"
            y="18"
            fontSize="11"
            fontFamily="system-ui,sans-serif"
          >
            a
          </text>
        </svg>
      </button>

      {open && (
        <div className="font-size-popover" role="dialog" aria-label={t.common.fontSize}>
          <div className="fsp-row">
            <span className="fsp-label-small">A</span>
            <input
              type="range"
              min={90}
              max={150}
              step={5}
              value={scale}
              onChange={e => setScale(parseInt(e.target.value, 10))}
              className="fsp-slider"
              aria-label={t.common.fontSize}
            />
            <span className="fsp-label-large">A</span>
          </div>
          {scale !== DEFAULT_SCALE && (
            <button className="fsp-reset" onClick={() => setScale(DEFAULT_SCALE)}>
              {t.common.reset}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
